"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AppAstra_1 = require("./classes/AppAstra");
const modalCom = require("@ivanlog/gs-com-modal_dialogs");
const tmpls_1 = require("./classes/com/tmpls");
const gs_1 = require("@ivanlog/gs");
gs_1.FormGS.TagClassName = 'astra-form';
gs_1.WrapperGS.ExtendComponentsByTagClass(gs_1.FormGS);
modalCom.Implement();
modalCom.AbstractDialog.HtmlTemplate = (new tmpls_1.ModalDialog).html;
globalThis.app = new AppAstra_1.AppAstra();
//# sourceMappingURL=index.js.map